/**
 * Collection Header Share Functionality
 * Handles share button in public collection header
 */

import { showToast } from './CollectionUI.js';

/**
 * Initialize share button functionality
 */
export function initCollectionHeaderShare() {
    /* Find share button in collection header */
    const shareButton = document.querySelector('.collection-share-btn');
    
    if (!shareButton) {
        return;
    }

    shareButton.addEventListener('click', handleShareClick);
}

/**
 * Handle share button click
 * @param {Event} event - Click event
 */
function handleShareClick(event) {
    const button = event.currentTarget;
    const collectionUrl = button.dataset.collectionUrl;
    
    if (!collectionUrl) {
        showToast('error', 'Không thể lấy link chia sẻ');
        return;
    }

    /* Copy to clipboard */
    if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(collectionUrl)
            .then(() => {
                showToast('success', 'Đã sao chép link chia sẻ vào clipboard!');
                /* Visual feedback */
                updateButtonState(button, 'copied');
            })
            .catch(() => {
                fallbackCopyText(collectionUrl, button);
            });
    } else {
        fallbackCopyText(collectionUrl, button);
    }
}

/**
 * Fallback copy text implementation for older browsers
 * @param {string} text - Text to copy
 * @param {HTMLElement} button - Share button element
 */
function fallbackCopyText(text, button) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-9999px';
    document.body.appendChild(textArea);
    textArea.select();

    try {
        const successful = document.execCommand('copy');
        if (successful) {
            showToast('success', 'Đã sao chép link chia sẻ vào clipboard!');
            updateButtonState(button, 'copied');
        } else {
            showToast('error', 'Không thể sao chép. Vui lòng sao chép thủ công: ' + text);
        }
    } catch (error) {
        showToast('error', 'Không thể sao chép. Vui lòng sao chép thủ công: ' + text);
    }

    document.body.removeChild(textArea);
}

/**
 * Update button visual state
 * @param {HTMLElement} button - Share button element
 * @param {string} state - Button state ('copied' or 'default')
 */
function updateButtonState(button, state) {
    if (state === 'copied') {
        const originalText = button.innerHTML;
        
        /* Show checkmark with green text */
        button.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lg:w-4 lg:h-4">
                <polyline points="20 6 9 17 4 12"/>
            </svg>
            Đã sao chép!
        `;
        button.classList.remove('text-blue-600', 'hover:text-blue-700');
        button.classList.add('!text-green-600');
        
        /* Reset after 2 seconds */
        setTimeout(() => {
            button.innerHTML = originalText;
            button.classList.remove('!text-green-600');
            button.classList.add('text-blue-600', 'hover:text-blue-700');
        }, 2000);
    }
}

/* Auto-initialize when DOM is ready */
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionHeaderShare);
} else {
    initCollectionHeaderShare();
}

